module.exports = __webpack_public_path__ + "static/media/barberscape-4.d6d0745e.jpg";